import { ReactNode, useState } from 'react';
import styles from './nav-item.module.css';
import { MaterialSymbolIcon } from '@/components/material-symbol-link';
import clsx from 'clsx';
import { Menu, MenuItem } from './menu';
import { useMediaQuery } from '@/hooks/use-media-query';

interface NavItemProps {
  children?: ReactNode;
  popupProps?: {
    items: MenuItem[];
    onItemClick?: () => void;
  };
  className?: string;
  isActive?: boolean;
}

export function NavItem({ children, popupProps, className, isActive }: NavItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const hasPopup = popupProps !== undefined;
  const isMobile = useMediaQuery('--screen-md');

  const showNavHeader = children || (!isMobile && hasPopup);

  return (
    <div
      className={clsx(styles.navItemContainer, className)}
      {...(hasPopup &&
        !isMobile && {
          onMouseEnter: () => setIsOpen(true),
          onMouseLeave: () => setIsOpen(false),
          onKeyDown: (e) => {
            if (e.key === ' ') {
              setIsOpen(!isOpen);
            }
          },
          tabIndex: 0,
          'aria-haspopup': true,
          'aria-expanded': isOpen,
        })}
    >
      {showNavHeader && (
        <span
          className={clsx(
            hasPopup && isMobile && 'body-3',
            styles.navItem,
            hasPopup && styles.navItemHeader,
            isActive && styles.active,
          )}
        >
          {children}
          {!isMobile && hasPopup && (
            <MaterialSymbolIcon
              className={clsx(styles.dropdownArrow, isOpen && styles.open)}
              name="keyboard_arrow_down"
            />
          )}
        </span>
      )}
      {hasPopup && (
        <Menu
          items={popupProps.items}
          isOpen={isOpen}
          onItemClick={() => {
            setIsOpen(false);
            popupProps.onItemClick?.();
          }}
        />
      )}
    </div>
  );
}
